import get from 'lodash/get'
import ResponsiveImage from './ResponsiveImage'
import RichContent from './RichContent'
import Section from './Section'
import { theme } from '../styles/theme'
import { createUseStyles } from '../helpers/createStyles'
import { useState, useEffect } from 'react'
import Button from './Button'
import { useSession } from 'next-auth/react'
import Accordion from '../components/Accordion'
import Carousel from '../components/Carousel'
import DetailPicker from '../components/DetailPicker'
import { getAllTepData } from '../store/tepStore'
import Card from './Card'
import { isBrowser } from '../lib/helpers'
import cn from 'classnames'

export default function TEPLandingPage ({ page, preview }) {
  const { status } = useSession()
  if (status === 'unauthenticated') {
    window.location.href = '/trade-exclusive-login'// Explicitly not using router.push to avoid an infinite loop bug
  }
  const styles = useStyles()

  const pageTitle = get(page, ['title'])
  const heroTitle = get(page, ['tepLandingHeroTitle'])
  const heroText = get(page, ['tepLandingHeroText'])
  const heroTextMobile = get(page, ['tepLandingHeroTextMobile'])
  const heroImage = get(page, ['tepLandingHeroImage'])
  const heroImageMobile = get(page, ['tepLandingHeroImageMobile'])

  const showInstruction = get(page, ['tepLandingShowInstruction'])
  const instructionTitle = get(page, ['tepLandingInstructionSectionTitle'])
  const instructionText = get(page, ['tepLandingInstructionSectionText'])
  const instructionImage = get(page, ['tepLandingInstructionSectionImage'])
  const instructionImageMobile = get(page, ['tepLandingInstructionSectionImageMobile'])
  const [isInstructionExpanded, setInstructionExpanded] = useState(false)

  const showCustomDesign = get(page, ['tepLandingShowCustomDesigns'])
  const customDesignTitle = get(page, ['tepLandingCustomDesignsTitle'])
  const customDesignContent = get(page, ['tepLandingCustomDesignsContent'])
  const [isCustomDesignExpanded, setCustomDesignExpanded] = useState(true)

  const showWeaves = get(page, ['tepLandingShowWeaves'])
  const weavesTitle = get(page, ['tepLandingWeavesTitle'])
  const weavesSubtitle = get(page, ['tepLandingWeavesSubtitle'])
  const weavesAddendum = get(page, ['tepLandingWeavesAddendum'])
  const [isWeavesExpanded, setWeavesExpanded] = useState(false)

  const showColours = get(page, ['tepLandingShowColours'])
  const coloursTitle = get(page, ['tepLandingColoursTitle'])
  const coloursSubtitle = get(page, ['tepLandingColoursSubtitle'])
  const coloursDescription = get(page, ['tepLandingColoursDescription'])
  const coloursFooterTitle = get(page, ['tepLandingColoursFooterTitle'])
  const coloursFooterDescription = get(page, ['tepLandingColoursFooterDescription'])
  const coloursAddendum = get(page, ['tepLandingColoursAddendum'])
  const [isColoursExpanded, setColoursExpanded] = useState(false)

  const showShapes = get(page, ['tepLandingShowShapes'])
  const shapesTitle = get(page, ['tepLandingShapesTitle'])
  const shapesSubtitle = get(page, ['tepLandingShapesSubtitle'])
  const shapesAddendum = get(page, ['tepLandingShapesAddendum'])
  const [isShapesExpanded, setShapesExpanded] = useState(false)

  const showCorners = get(page, ['tepLandingShowCorners'])
  const cornersTitle = get(page, ['tepLandingCornersTitle'])
  const cornersSubtitle = get(page, ['tepLandingCornersSubtitle'])
  const cornersDescription = get(page, ['tepLandingCornersDescription'])
  const cornersFooterTitle = get(page, ['tepLandingCornersFooterTitle'])
  const cornersFooterDescription = get(page, ['tepLandingCornersFooterDescription'])
  const cornersAddendum = get(page, ['tepLandingCornersAddendum'])
  const [isCornersExpanded, setCornersExpanded] = useState(false)

  const showFinishes = get(page, ['tepLandingShowFinishes'])
  const finishesTitle = get(page, ['tepLandingFinishesTitle'])
  const finishesSubtitle = get(page, ['tepLandingFinishesSubtitle'])
  const finishesAddendum = get(page, ['tepLandingFinishesAddendum'])
  const [isFinishesExpanded, setFinishesExpanded] = useState(false)

  const showSize = get(page, ['tepLandingShowSize'])
  const sizeTitle = get(page, ['tepLandingSizeTitle'])
  const sizeSubtitle = get(page, ['tepLandingSizeSubtitle'])
  const sizeContent = get(page, ['tepLandingSizeContent'])
  const sizeAddendum = get(page, ['tepLandingSizeAddendum'])
  const [isSizeExpanded, setSizeExpanded] = useState(false)

  const showHeight = get(page, ['tepLandingShowHeight'])
  const heightTitle = get(page, ['tepLandingHeightTitle'])
  const heightSubtitle = get(page, ['tepLandingHeightSubtitle'])
  const heightContent = get(page, ['tepLandingHeightContent'])
  const heightAddendum = get(page, ['tepLandingHeightAddendum'])
  const [isHeightExpanded, setHeightExpanded] = useState(false)

  const showBacking = get(page, ['tepLandingShowBacking'])
  const backingTitle = get(page, ['tepLandingBackingTitle'])
  const backingSubtitle = get(page, ['tepLandingBackingSubtitle'])
  const backingContent = get(page, ['tepLandingBackingContent'])
  const backingAddendum = get(page, ['tepLandingBackingAddendum'])
  const backingImage = get(page, ['tepLandingBackingImage'])
  const backingImageMobile = get(page, ['tepLandingBackingImageMobile'])
  const [isBackingExpanded, setBackingExpanded] = useState(false)

  const showEnquire = get(page, ['tepLandingShowEnquire'])
  const enquireTitle = get(page, ['tepLandingEnquireTitle'])
  const enquireSubtitle = get(page, ['tepLandingEnquireSubtitle'])
  const enquireText = get(page, ['tepLandingEnquireText'])
  const enquireContent = get(page, ['tepLandingEnquireContent'])
  const enquireButtonText = get(page, ['tepLandingEnquireButtonText'])
  const enquireAddendum = get(page, ['tepLandingEnquireAddendum'])
  const [isEnquireExpanded, setEnquireExpanded] = useState(false)

  const showPartners = get(page, ['tepLandingShowPartners'])
  const partnersTitle = get(page, ['tepLandingPartnersTitle'])
  const partnersSubtitle = get(page, ['tepLandingPartnersSubtitle'])
  const partnersAddendum = get(page, ['tepLandingPartnersAddendum'])
  const partnersGroup1Title = get(page, ['tepLandingPartnersGroup1Title'])
  const partnersGroup1Images = get(page, ['tepLandingPartnersGroup1Images'])
  const partnersGroup2Title = get(page, ['tepLandingPartnersGroup2Title'])
  const partnersGroup2Images = get(page, ['tepLandingPartnersGroup2Images'])
  const partnersGroup3Title = get(page, ['tepLandingPartnersGroup3Title'])
  const partnersGroup3Images = get(page, ['tepLandingPartnersGroup3Images'])
  const [isPartnersExpanded, setPartnersExpanded] = useState(false)

  const [tepProducts, setTepProducts] = useState([])
  const [tepProductColors, setTepProductColors] = useState([])
  const [tepProductCorners, setTepProductCorners] = useState([])
  const [tepProductFinishes, setTepProductFinishes] = useState([])
  const [tepProductShapes, setTepProductShapes] = useState([])

  const [, setTepProductsTotal] = useState(0)
  const [, setTepProductColorsTotal] = useState([])
  const [, setTepProductCornersTotal] = useState([])
  const [, setTepProductFinishesTotal] = useState([])
  const [, setTepProductShapesTotal] = useState([])

  const [loading, setLoading] = useState(true)
  const [, setError] = useState(null)

  const [isMobile, setIsMobile] = useState(true)
  const handleResize = () => {
    const isMobileSize = window.innerWidth < theme.breakpoints.values.md
    setIsMobile(window.innerWidth < theme.breakpoints.values.md)

    // Set all accordion expanded to true if not mobile
    if (!isMobileSize) {
      setInstructionExpanded(true)
      setCustomDesignExpanded(true)
      setWeavesExpanded(true)
      setColoursExpanded(true)
      setShapesExpanded(true)
      setCornersExpanded(true)
      setFinishesExpanded(true)
      setSizeExpanded(true)
      setHeightExpanded(true)
      setBackingExpanded(true)
      setEnquireExpanded(true)
    }
  }

  async function fetchTEPData () {
    try {
      setLoading(true)
      const result = await getAllTepData()
      console.log('TEP Data:', result)

      setTepProducts(result.tepProducts || [])
      setTepProductColors(result.tepProductColors || [])
      setTepProductCorners(result.tepProductCorners || [])
      setTepProductFinishes(result.tepProductFinishes || [])
      setTepProductShapes(result.tepProductShapes || [])

      setTepProductsTotal(result.tepProducts.length || 0)
      setTepProductColorsTotal(result.tepProductColors.length || 0)
      setTepProductCornersTotal(result.tepProductCorners.length || 0)
      setTepProductFinishesTotal(result.tepProductFinishes.length || 0)
      setTepProductShapesTotal(result.tepProductShapes.length || 0)
      setError(null)
    } catch (err) {
      setError(err.message)
      console.log('Error fetching TEP data:', err)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (tepProducts.length === 0) {
      fetchTEPData()
    }
    if (isBrowser) {
      window.addEventListener('resize', handleResize)
      handleResize()
    }
  }, [])

  if (status === 'loading') {
    return <p>Loading...</p>
  }

  if (status === 'unauthenticated') {
    return (
      <Section className={styles.section} fullWidth>
        {/* Hero */}
        <div className={styles.tep_landing_hero}>
          <div className={styles.heroContainer}>
            <ResponsiveImage image={heroImage} mobileImage={heroImageMobile} className={styles.heroImage} />
            <div className={styles.heroContent}>
              <h1 className={styles.heroTitle}>Access Denied</h1>
              <RichContent className={styles.heroContent} content='Please login to access this restricted page' />
              <Button to='trade-exclusive-login' className={styles.darkenedButton}>Log In</Button>
              <Button to='trade-registration-form' className={styles.darkenedButton}>Sign Up</Button>
            </div>
          </div>
        </div>
      </Section>
    )
  }

  return (
    <Section className={styles.mainSection} fullWidth>

      <div className={styles.heroContainer}>
        <h1 className={styles.pageTitle}>{pageTitle}</h1>
        <div className={styles.flexRow}>
          {/* <h2 className={styles.heroTitle}>{heroTitle.split(', ')[0]},<br></br>{heroTitle.split(', ')[1]}</h2> */}
          <RichContent className={[styles.heroTitle]} content={heroTitle} />
          <RichContent className={[styles.heroContent, 'desktopOnly']} content={heroText} />
          <RichContent className={[styles.heroContent, 'mobileOnly']} content={heroTextMobile} />
        </div>
        <ResponsiveImage image={heroImage} mobileImage={heroImageMobile} className={styles.heroImage} />
      </div>

      {showInstruction && (
        <Accordion
          className={['tepAccordion', 'shade4', 'noBottomPadding']}
          label={instructionTitle}
          expanded={isInstructionExpanded}
          setExpanded={setInstructionExpanded}
        >
          <div className={styles.flexCol}>
            <RichContent className={styles.introText} content={instructionText} />
            {instructionImage && (
              <ResponsiveImage image={instructionImage} mobileImage={instructionImageMobile} className={['desktopOnly', styles.introImage]} />
            )}
            {instructionImageMobile && (
              <ResponsiveImage image={instructionImageMobile} mobileImage={instructionImageMobile} className={['mobileOnly', styles.introImage]} />
            )}
          </div>
        </Accordion>
      )}

      {showCustomDesign && (
        <Accordion
          className={['tepAccordion', 'shade3', 'noBottomPadding']}
          label={customDesignTitle}
          expanded={isCustomDesignExpanded}
          setExpanded={setCustomDesignExpanded}
          hideCollapseButton={!isMobile}
        >
          <div className={cn(styles.contentList, styles.customDesignText)}>
            {customDesignContent?.map((item, index) => (
              <RichContent key={index} content={item.value} />
            ))}
          </div>

          {showWeaves && (
            <Accordion
              className={['tepAccordion', 'shade2']}
              label={weavesTitle}
              expanded={isWeavesExpanded}
              setExpanded={setWeavesExpanded}
            >
              <div className={styles.flexRow}>
                <RichContent className={styles.accordionText} content={weavesSubtitle} />
              </div>
              {weavesAddendum && <RichContent className={styles.addendum} content={weavesAddendum} />}
              {(loading || !tepProducts || tepProducts.length === 0) && <div className={styles.spinner}>Loading...</div>}
              <div>

                <Carousel itemsLabel='WEAVE' className={styles.topPaddingCarousel}>
                  {Array.isArray(tepProducts) && tepProducts.map((product, index) => (
                    <Card isMobile={isMobile} key={index} cardContent={product} />
                  ))}
                </Carousel>

                {/* <pre>{JSON.stringify(tepProducts, null, 2)}</pre> */}

              </div>
            </Accordion>
          )}

          {showColours && (
            <Accordion
              className={['tepAccordion', 'shade2', 'noTopPaddingDesktop']}
              label={coloursTitle}
              expanded={isColoursExpanded}
              setExpanded={setColoursExpanded}
            >

              {loading && <div className={styles.spinner}>Loading...</div>}
              <div className={cn(styles.flexRow, 'mobileOnly', styles.bottomPadding12)}>
                <RichContent className={styles.accordionText} content={coloursDescription} />
                {coloursAddendum && <RichContent className={styles.addendum} content={coloursAddendum} />}
              </div>
              <div className={cn(styles.detailPickerContainer, 'detailPickerContainer')}>
                <DetailPicker
                  items={tepProductColors} defaultItem={{
                    subtitle: coloursSubtitle,
                    description: coloursDescription,
                    footerTitle: coloursFooterTitle,
                    footerDescription: coloursFooterDescription,
                    addendum: coloursAddendum,
                    itemName: 'COLOUR',
                    selectedSubtitle: 'COLOUR NAME',
                    selectedFooterTitle: 'Colour Characteristics:'
                  }}
                />
              </div>

              {/* <pre>{JSON.stringify(tepProductColors, null, 2)}</pre> */}

            </Accordion>
          )}

          {showShapes && (
            <Accordion
              className={['tepAccordion', 'shade2']}
              label={shapesTitle}
              expanded={isShapesExpanded}
              setExpanded={setShapesExpanded}
            >
              <div className={styles.flexRow}>
                <RichContent className={styles.accordionText} content={shapesSubtitle} />
              </div>
              {shapesAddendum && <RichContent className={styles.addendum} content={shapesAddendum} />}
              <Carousel itemsLabel='SHAPE' className={styles.topPaddingCarousel} showMobilePreview={false}>
                {Array.isArray(tepProductShapes) && tepProductShapes.map((shape, index) => (
                  <Card isMobile={isMobile} key={index} cardContent={shape} />
                ))}
              </Carousel>

            </Accordion>
          )}
          {showCorners && (
            <Accordion
              className={['tepAccordion', 'shade2', 'noTopPaddingDesktop']}
              label={cornersTitle}
              expanded={isCornersExpanded}
              setExpanded={setCornersExpanded}
            >
              <div className={styles.detailPickerContainer}>
                <DetailPicker
                  items={tepProductCorners}
                  showMobilePreview={false}
                  hidePagination
                  defaultItem={{
                    subtitle: cornersSubtitle,
                    description: cornersDescription,
                    footerTitle: cornersFooterTitle,
                    footerDescription: cornersFooterDescription,
                    addendum: cornersAddendum,
                    itemName: 'CORNER',
                    selectedSubtitle: 'CORNER NAME',
                    selectedFooterTitle: 'FEATURES:'
                  }}
                />
              </div>

            </Accordion>
          )}
          {showFinishes && (
            <Accordion
              className={['tepAccordion', 'shade2']}
              label={finishesTitle}
              expanded={isFinishesExpanded}
              setExpanded={setFinishesExpanded}
            >
              <div className={styles.flexRow}>
                <RichContent className={styles.accordionText} content={finishesSubtitle} />
              </div>
              {finishesAddendum && <RichContent className={styles.addendum} content={finishesAddendum} />}

              <Carousel itemsLabel='FINISH' className={styles.topPaddingCarousel}>
                {Array.isArray(tepProductFinishes) && tepProductFinishes.map((finish, index) => (
                  <Card isMobile={isMobile} key={index} cardContent={finish} />
                ))}
              </Carousel>

            </Accordion>
          )}
          {showSize && (
            <Accordion
              className={['tepAccordion', 'shade2']}
              label={sizeTitle}
              expanded={isSizeExpanded}
              setExpanded={setSizeExpanded}
            >
              <RichContent className={styles.accordionText} content={sizeSubtitle} />
              <div className={styles.contentList}>
                {sizeContent?.map((item, index) => (
                  <RichContent key={index} content={item.value} />
                ))}
              </div>
              <div className={styles.contentList}>
                <div />
                {sizeAddendum && <RichContent className={styles.addendum} content={sizeAddendum} />}
              </div>
            </Accordion>
          )}
          {showHeight && (
            <Accordion
              className={['tepAccordion', 'shade2']}
              label={heightTitle}
              expanded={isHeightExpanded}
              setExpanded={setHeightExpanded}
            >
              <RichContent className={styles.accordionText} content={heightSubtitle} />
              <div className={styles.contentList}>
                {heightContent?.map((item, index) => (
                  <RichContent key={index} content={item.value} />
                ))}
              </div>
              <div className={styles.contentList}>
                <div />
                {heightAddendum && <RichContent className={styles.addendum} content={heightAddendum} />}
              </div>
            </Accordion>
          )}
          {showBacking && (
            <Accordion
              className={['tepAccordion', 'shade2']}
              label={backingTitle}
              expanded={isBackingExpanded}
              setExpanded={setBackingExpanded}
            >
              <RichContent className={styles.accordionText} content={backingSubtitle} />
              <div className={styles.contentList}>
                {backingContent?.map((item, index) => (
                  <RichContent key={index} content={item.value} />
                ))}
              </div>
              <div className={styles.contentList}>
                <div />
                {backingAddendum && <RichContent className={styles.addendum} content={backingAddendum} />}
              </div>

              {backingImage && (
                <ResponsiveImage image={backingImage} mobileImage={backingImageMobile} className={['desktopOnly', styles.nestedImage, styles.marginTop]} />
              )}
              {backingImageMobile && (
                <ResponsiveImage image={backingImageMobile} mobileImage={backingImageMobile} className={['mobileOnly', styles.nestedImage, styles.marginTop]} />
              )}

            </Accordion>
          )}

        </Accordion>
      )}

      {showEnquire && (
        <Accordion
          className={['tepAccordion', 'shade1']}
          label={enquireTitle}
          expanded={isEnquireExpanded}
          setExpanded={setEnquireExpanded}
        >
          <div className={cn(styles.contentList, styles.enquireContent)}>
            <RichContent className={styles.accordionText} content={enquireSubtitle} />
            <RichContent className={styles.accordionText} content={enquireText} />
          </div>
          <div className={cn(styles.contentList, styles.enquireContent)}>
            {enquireContent?.map((item, index) => (
              <RichContent key={index} className={styles.accordionText} content={item.value} />
            ))}
          </div>
          <div className={styles.contentList}>
            {enquireAddendum && <RichContent className={styles.addendum} content={enquireAddendum} />}
            <div>

              <button
                className={styles.enquireButton}
                onClick={() => { window.location.href = 'mailto:test@test.com' }}
              >
                {enquireButtonText}

              </button>
            </div>
          </div>
        </Accordion>
      )}

      {showPartners && (
        <Accordion
          className={['tepAccordion', 'shade4', 'partnersAccordion']}
          label={partnersTitle}
          expanded={isPartnersExpanded}
          setExpanded={setPartnersExpanded}
        >
          <div className={`${styles.flexRow} ${styles.partnersIntro}`}>
            <RichContent className={styles.accordionText} content={partnersSubtitle} />
            {partnersAddendum && <RichContent className={styles.addendum} content={partnersAddendum} />}
          </div>
          <br />

          <h3 className={styles.partnersTitle}>{partnersGroup1Title}</h3>
          <div className={styles.flexRow}>
            <Carousel itemsLabel='PARTNER' className={`${styles.partnersContainer} partnersContainer`} isSimpleGrid showMobilePreview={false} showArrows={false} hidePaginationLabel>
              {Array.isArray(partnersGroup1Images) && partnersGroup1Images.map((image, index) => (
                <ResponsiveImage key={index} image={image} mobileImage={image} className={`${styles.partnersImage}, 'partnersImage'`} />
              ))}
            </Carousel>
          </div>

          <h3 className={styles.partnersTitle}>{partnersGroup2Title}</h3>
          <div className={styles.flexRow}>
            <Carousel itemsLabel='PARTNER' className={`${styles.partnersContainer} partnersContainer`} isSimpleGrid showMobilePreview={false} showArrows={false} hidePaginationLabel>
              {Array.isArray(partnersGroup2Images) && partnersGroup2Images.map((image, index) => (
                <ResponsiveImage key={index} image={image} mobileImage={image} className={`${styles.partnersImage}, 'partnersImage'`} />
              ))}
            </Carousel>

          </div>

          <h3 className={styles.partnersTitle}>{partnersGroup3Title}</h3>
          <div className={styles.flexRow}>
            <Carousel itemsLabel='PARTNER' className={`${styles.partnersContainer} partnersContainer`} isSimpleGrid showMobilePreview={false} showArrows={false} hidePaginationLabel>
              {Array.isArray(partnersGroup3Images) && partnersGroup3Images.map((image, index) => (
                <ResponsiveImage key={index} image={image} mobileImage={image} className={`${styles.partnersImage}, 'partnersImage'`} />
              ))}
            </Carousel>
          </div>

        </Accordion>
      )}
      {/*
      <Button
        className={styles.darkenedButton}
        onClick={signOut}
      >
        Sign Out
      </Button> */}

    </Section>
  )
}
const useStyles = createUseStyles({
  flexRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: theme.spacing(4)
    },
    justifyContent: 'space-between'
  },
  flexCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  mainSection: {
    paddingTop: theme.spacing(9),
    backgroundColor: '#AFAC9C',
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(12)
    }
  },

  pageTitle: {
    color: theme.colors.black,
    fontFamily: 'Iskry',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: '6px',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(8),
    [theme.breakpoints.up('md')]: {
      fontSize: 30,
      marginBottom: theme.spacing(12)
    }
  },

  heroContainer: {
    borderTop: '1px solid black',
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8),
      paddingBottom: theme.spacing(0)
    }
  },

  heroTitle: {
    color: theme.colors.black,
    fontFamily: 'Iskry',
    fontStyle: 'normal',
    fontWeight: 700,
    width: '100%',
    minWidth: '50%',
    ' & p, div, h1, h2, h3, h4, h5, h6': {
      width: '100%',
      minWidth: '100%',
      fontSize: 28,
      [theme.breakpoints.up('md')]: {
        fontSize: 70
      },
      ' & h2': {
        fontSize: '30px !important',
        [theme.breakpoints.up('md')]: {
          fontSize: '62px !important'
        }
      }
    }
  },
  heroContent: {
    '& p': {
      fontFamily: 'Sohne !important',
      fontWeight: 300,
      fontSize: '14px !important',
      [theme.breakpoints.up('md')]: {
        fontSize: '20px !important'
      }
    }
  },

  heroImage: {
    width: '100vw !important',
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(-4),
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(-8)
    }
  },

  introImage: {
    width: '100vw !important',
    marginLeft: theme.spacing(-12)
  },

  nestedImage: {
    width: '100vw !important',
    marginLeft: theme.spacing(-4),
    marginBottom: theme.spacing(-4),

    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(-12),
      marginBottom: theme.spacing(-12)
    }
  },

  detailPickerContainer: {
    // width: '100vw !important',
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(-12),
      marginBottom: theme.spacing(-12),
      width: '100vw',
      paddingRight: theme.spacing(6)
    }
  },
  marginTop: {
    marginTop: theme.spacing(4)
  },

  contentList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    justifyContent: 'space-between',
    p: {
      fontSize: 14
    },
    ' & > :nth-child(1)': {
      p: {
        fontFamily: 'Iskry',
        fontSize: 24
      }
    },

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: theme.spacing(38),
      p: {
        fontSize: 20
      },
      '& > :nth-child(1)': {
        fontSize: 26,
        p: {
          fontSize: 26
        }
      }
    },

    '& > *': {
      [theme.breakpoints.up('md')]: {
        flex: 1
      }
    }

  },

  enquireContent: {
    '& > :nth-child(1)': {
      fontFamily: 'Iskry',
      '& p': {
        fontFamily: 'Iskry',
        fontSize: 20
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 40,
        '& p': {
          fontSize: 40
        }
      }
    }
  },

  addendum: {
    fontSize: '14px !important',
    opacity: 0.3,
    width: '100%',
    display: 'flex',
    paddingTop: theme.spacing(2),
    justifyContent: 'flex-start',
    '& p': {
      fontFamily: 'Sohne',
      fontWeight: 300,
      fontSize: '14px !important'
    }
  },

  accordionText: {
    fontFamily: 'Sohne',
    fontWeight: 300,
    fontSize: 14,
    paddingBottom: theme.spacing(0),
    '& p': {
      fontSize: 14
    },
    [theme.breakpoints.up('md')]: {
      '& p': {
        fontSize: 24
      },

      '& > :nth-child(1)': {
        fontSize: 26,
        '& p': {
          fontSize: 26
        }
      }
    }

  },
  topPaddingCarousel: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      paddingTop: '50px'
    }
  },
  topPadding12: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(12)
    }
  },
  bottomPadding12: {
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(12)
    }
  },

  customDesignText: {
    paddingBottom: theme.spacing(8)
  },

  introText: {
    paddingBottom: theme.spacing(12),
    p: {
      fontFamily: 'Sohne',
      fontWeight: 300,
      fontSize: 14,
      [theme.breakpoints.up('md')]: {
        fontSize: 24
      }
    },

    ul: {
      listStyleType: 'none',
      paddingLeft: 0,
      h2: {
        width: '100%',
        fontFamily: 'Iskry',
        fontSize: 24,
        fontWeight: 700,
        display: 'table-header-group',
        [theme.breakpoints.up('md')]: {
          fontSize: 50
        },
        h3: {
          fontSize: 22,
          textWrapMode: 'nowrap',
          li: {
            fontFamily: 'Sohne',
            textWrapMode: 'wrap',
            paddingTop: theme.spacing(2),
            fontSize: 14
          }
        }
      }
    },
    '& div > p': { // targer the description before the list
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing(3)
      }
    },
    '& div > ul:first-of-type': { // Only target the first ul
      counterReset: 'introListCounter',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        gap: theme.spacing(4),
        flexWrap: 'wrap',
        justifyContent: 'center'
      },
      [theme.breakpoints.up('xl')]: {
        gap: theme.spacing(16)
      },

      '& ul': { // Target all nested uls
        [theme.breakpoints.up('md')]: {
          paddingTop: theme.spacing(3)
        }
      },

      '> li': { // Only target direct children
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          flexBasis: '48%'
        },
        [theme.breakpoints.up('lg')]: {
          flexBasis: '0%'
        },
        counterIncrement: 'introListCounter',
        paddingBottom: theme.spacing(2),
        '&::before': {
          content: 'counter(introListCounter, decimal-leading-zero)',
          marginRight: theme.spacing(2),
          marginTop: theme.spacing(1),
          fontFamily: 'Sohne-Breit-Leicht',
          fontWeight: 400,
          fontSize: 12,
          letterSpacing: '1px'
        }
      }
    }
  },

  enquireButton: {
    fontFamily: 'Sohne',
    fontWeight: 400,
    fontSize: 14,
    borderRadius: 90,
    border: '1px solid darkgrey',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#AFAC9C',
      color: theme.colors.white
    }
  },

  partnersIntro: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(12),
      paddingRight: theme.spacing(12)
    }
  },

  partnersContainer: {
    paddingBottom: theme.spacing(4),
    backgroundColor: '#8e8b7d',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(12),
      paddingRight: theme.spacing(12)
    },
    overflow: 'hidden',
    '& div': {
      maxWidth: '100%'
    },
    '& > div:last-child': {
      maxHeight: 'fit-content',
      gridTemplateRows: 'auto',
      [theme.breakpoints.down('sm')]: {
        gridTemplateRows: 'repeat(2, 1fr)', // uncomment these three lines if the client wants the mobile to be 2 rows by 3 columns
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridAutoFlow: 'dense'
      },

      [theme.breakpoints.up('md')]: {
        // gridTemplateRows: 'auto',
      },
      '& > *': { // Target the last direct child div's children
        // border: '10px solid red',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }
  },

  partnersTitle: {
    fontSize: 12,
    fontFamily: 'Sohne',
    fontWeight: 400,
    color: theme.colors.black,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    backgroundColor: '#8e8b7d',
    marginBottom: 0,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(12),
      paddingRight: theme.spacing(12)
    }
  },

  '#logo': {
    color: 'black !important'
  }
})
